import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import { addArticle } from "../state-management/actions/article-actions";
import ArticleComponent from "../components/article";
import { ArticleDataProps } from "../types/public";
import {
  setAlert,
  setAlertContext,
  setAlertSeverity,
} from "../state-management/actions/alerts-actions";
import { addNotification } from "../state-management/actions/notification-actions";
import { createNotificationData } from "../utils/createNotificationData";

export default function AddArticle() {
  const dispatch = useDispatch();
  const { currentUserData, groupingData, departmentsData } =
    useSelector(selectGlobalState);
  const initialData = {
    title: "",
    department_id: "",
    content: "",
    author: "",
    created_by: currentUserData._id,
    index_picture: "",
    tags: "",
    is_active: false,
    description: "",
    avatar: currentUserData.picture,
  };
  const [formData, setFormData] = useState<ArticleDataProps>(initialData);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: ArticleDataProps): Promise<boolean> => {
    try {
      setLoading(true);
      const data = {
        ...values,
        tags: values.tags.split("،").map((tag: string) => tag.trim()),
      };

      const response = await addArticle(data)(dispatch);
      if (response?.status === 200) {
        setFormData(initialData);
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext("ثبت مقاله با موفقیت صورت پذیرفت"));
        const notificationData = createNotificationData({
          data,
          departmentsData,
          currentUserData,
          groupingData,
          type: "create",
          subject: "مقاله",
        });
        await addNotification(notificationData)(dispatch);
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      setLoading(false);
    }
  };
  return (
    <ArticleComponent
      handleSubmit={handleSubmit}
      formData={formData}
      setFormData={setFormData}
      currentUserId={currentUserData._id}
      loading={loading}
    />
  );
}
